<div class="ui-g container" *ngIf="rouletteDetails" provide-parent-form>
    <div class="roulette-type-header">{{getRouletteTypeText() | translate}}</div>
    
    <div class="r-form-group">
        <label class="title" for="rouletteLink">{{'ROULETTE.LINK_ROULETTE'|translate}}</label>
        <div class="link-with-copy row">
            <button class="copy" pTooltip="{{'ROULETTE.COPY'|translate}}"
                [copyToClipboard]="rouletteDetails.RouletteLink"><i class="pi pi-copy"></i></button>
            <span class="link"><a target="_blank" rel="noopener noreferrer"
                    href="{{rouletteDetails.RouletteLink}}">{{rouletteDetails.RouletteLink}}</a></span>
        </div>
    </div>

    <div class="r-form-group" *ngIf="rouletteDetails.IsAllowToSendCampain">
        <button class="command-button full full-width send-campaign-open-btn" type="button"
            (click)="openSendCampaignDialog()">{{'ROULETTE.SEND_CAMPAIGN_TO_ALL_LEADS'|translate}}</button>
        <p-dialog [header]="'ROULETTE.SEND_CAMPAIGN_CONFIRM_TITLE' | translate"
            [(visible)]="showSendCampaignDialog" [modal]="true" [closable]="true"
            styleClass="send-campaign-dialog"
            [style]="{ width: '380px' }">
            <div class="sc-body">
                <p class="sc-description">{{'ROULETTE.SEND_TO_ROULETTE_LABEL' | translate}}</p>
                <p-dropdown
                    [options]="roulettesNames"
                    [(ngModel)]="selectedRouletteForSend"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{'LIDS.ALL_ROULETTES' | translate}}"
                    [showClear]="true"
                    appendTo="body"
                    (onChange)="onRouletteForSendChange($event)"
                    [style]="{ width: '100%' }">
                </p-dropdown>
            </div>
            <p-footer>
                <div class="sc-footer">
                    <button class="sc-btn sc-btn-cancel" type="button" (click)="showSendCampaignDialog = false">{{'GENERAL.CANCEL' | translate}}</button>
                    <button class="sc-btn sc-btn-confirm" type="button" (click)="confirmSendCampaign()">{{'GENERAL.OK' | translate}}</button>
                </div>
            </p-footer>
        </p-dialog>
    </div>

    <div class="r-form-group">
        <label class="title" for="name">{{'ROULETTE.ROULETTE_NAME(NOT_SHOWN_TO_CUSTOMERS)'|translate}}</label>
        <input type="text" name="name" #name="ngModel" [(ngModel)]="rouletteDetails.Name" required maxlength="50">
        <div *ngIf="!name.valid && name.errors.required" class="error-required">
            {{'ERRORS.REQUIRED' | translate}}
        </div>
    </div>
    <div class="r-form-group note-to-customers-text">
        <label class="title" for="comment">{{'ROULETTE.NOTE_TO_CUSTOMERS'|translate}}</label>
        <textarea style="width:100%" name="comment" #comment="ngModel" [(ngModel)]="rouletteDetails.Comment" rows="3"
            cols="30" maxlength="500"></textarea>
        <div *ngIf="!comment.valid">
            {{'ERRORS.REQUIRED' | translate}}
        </div>
    </div>
    <div class="r-form-group">
        <button class="command-button full full-width" type="button"
            (click)="showDialog()">{{'CUSTOMER_FIELDS.BUTTON_OPEN_DIALOG'|translate}}</button>
        <p-dialog [header]="'CUSTOMER_FIELDS.TITLE' | translate"
            [(visible)]="displayDialog" [modal]="true" [closable]="true" 
            [style]="{ width: '690px', 'min-height': '300px'}"
            (onHide)="closeDialog()" class="custom-dialog">
            <app-field-dialog [roulette]="roulette" [form]="form"  (fieldsUpdated)="onFieldsUpdated($event)"></app-field-dialog>
        </p-dialog>
    </div>
    <div class="r-form-group">
        <label class="title"
            for="expireDays">{{'ROULETTE.EXPIRATION_OF_A_PRIZE_FROM_THE_DATE_OF_RECEIPT'|translate}}</label>
        <p-dropdown [options]="expireDaysOptions" [appendTo]="null" inputId="expireDays" #expireDays="ngModel"
            name="expireDays" [(ngModel)]="rouletteDetails.ExpireDays">
            <ng-template pTemplate="selectedItem">
                {{rouletteDetails.ExpireDays|appendtext:'ROULETTE.DAYS'}}
            </ng-template>
            <ng-template let-item pTemplate="item">
                {{item|appendtext:'ROULETTE.DAYS'}}
            </ng-template>
        </p-dropdown>
        <div *ngIf="!expireDays.valid && expireDays.errors.required" class="error-required">
            {{'ERRORS.REQUIRED' | translate}}
        </div>
    </div>

    <div class="r-form-group">
        <label class="title" for="sendCouponBy">{{'ROULETTE.SEND_COUPON_BY'|translate}}</label>
        <p-multiSelect 
            [options]="sendByTypes" 
            [(ngModel)]="roulette.SendCouponBy" 
            optionLabel="Description" 
            optionValue="Id"
            inputId="sendCouponBy" 
            #sendCouponBy="ngModel"
            name="sendCouponBy"
            appendTo="body"
            [showHeader]="false"
            display="chip"
            required>
            <ng-template pTemplate="selectedItems">
                <span *ngIf="roulette.SendCouponBy && roulette.SendCouponBy.length > 0" class="selected-items-text">
                    {{getSelectedSendMethodsText()}}
                </span>
                <span *ngIf="!roulette.SendCouponBy || roulette.SendCouponBy.length === 0" class="placeholder">
                    {{'ROULETTE.SELECT_SEND_METHODS'|translate}}
                </span>
            </ng-template>
            <ng-template let-option pTemplate="item">
                {{'ROULETTE.' + option.Description.toUpperCase() | translate}}
            </ng-template>
        </p-multiSelect>
        <div *ngIf="!sendCouponBy.valid && sendCouponBy.errors?.required" class="error-required">
            {{'ERRORS.REQUIRED' | translate}}
        </div>
    </div>

    <div class="row r-form-group switch-container">
        <label class="title" for="available">{{'ROULETTE.ACTIVE_ROULETTE'|translate}}</label>
        <p-inputSwitch name="available" [ngModel]="isAvailable" [disabled]="true"></p-inputSwitch>
    </div>
    <div *ngIf="showAutoRenwal" class="row r-form-group switch-container">
        <label class="title bold-text"
            for="autoRenewal">{{'ROULETTE.AUTOMATIC_RENEWAL_AT_THE_END_OF_THE_PERIOD'|translate}}</label>
        <p-inputSwitch name="autoRenewal" [(ngModel)]="rouletteDetails.AutoRenewalPackage"
            (onChange)="changeAutoRenewal($event)"></p-inputSwitch>
    </div>
    <div *ngIf="showCancelSubscription" class="r-form-group">
        <button class="command-button full full-width cancel-subscription-btn" type="button"
            [disabled]="rouletteDetails.IsSubscriptionCanceled"
            [class.cancelled]="rouletteDetails.IsSubscriptionCanceled"
            (click)="cancelSubscription()">
            <span *ngIf="!rouletteDetails.IsSubscriptionCanceled">{{'ROULETTE.CANCEL_SUBSCRIPTION'|translate}}</span>
            <span *ngIf="rouletteDetails.IsSubscriptionCanceled">{{'ROULETTE.SUBSCRIPTION_ALREADY_CANCELLED'|translate}}</span>
        </button>
    </div>
    <div *ngIf="rouletteDetails.CreatedDate">
        <label class="date-label" for="createdDate">{{'ROULETTE.CREATE_DATE'|translate}}
            {{rouletteDetails.CreatedDate+'z'
            | date: 'HH:mm dd/MM/yyyy'}}</label>
    </div>

    <div *ngIf="rouletteDetails.UpdatedDate">
        <label class="date-label">{{'ROULETTE.UPDATE_DATE'|translate}} {{rouletteDetails.UpdatedDate+'z'
            | date: 'HH:mm dd/MM/yyyy' }}</label>
    </div>

    <!-- Developer Settings Section -->
    <div class="r-form-group" style="margin-top: 40px;">
        <h3 class="section-title">{{'ROULETTE.DEVELOPER_SETTINGS'|translate}}</h3>
        <div class="link-with-copy row">
            <button class="copy" pTooltip="{{'ROULETTE.COPY'|translate}}"
                [copyToClipboard]="getIframeLink(rouletteDetails.RouletteLink)"><i class="pi pi-copy"></i></button>
            <span class="link"><a target="_blank" rel="noopener noreferrer"
                    href="{{getIframeLink(rouletteDetails.RouletteLink)}}">{{'ROULETTE.IFRAME_EMBED_LINK'|translate}}</a></span>
        </div>
        <div class="link-with-copy row" style="margin-top: 10px;">
            <button class="copy" pTooltip="{{'ROULETTE.COPY'|translate}}"
                [copyToClipboard]="getFullIframeCode(rouletteDetails.RouletteLink)"><i class="pi pi-copy"></i></button>
            <span class="link"><a style="cursor: pointer;">{{'ROULETTE.COPY_IFRAME_CODE'|translate}}</a></span>
        </div>
        <div class="link-with-copy row" style="margin-top: 10px;">
            <button class="copy" pTooltip="{{'ROULETTE.DOWNLOAD'|translate}}"
                (click)="downloadIframeDoc()"><i class="pi pi-download"></i></button>
            <span class="link"><a (click)="downloadIframeDoc()" style="cursor: pointer;">{{'ROULETTE.DOWNLOAD_IFRAME_DOC'|translate}}</a></span>
        </div>
    </div>
</div>